import type { FC } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import { useToast } from "@/hooks/useToast";
import ToastProvider from "@/ui/composed/toast/ToastProvider";
import { Button } from "@/ui/core";
import { Box } from "@/ui/layout";

const StoryMeta: Meta = {
  title: "Components/Toast/Toast",
  component: ToastProvider,
  decorators: [
    (Story) => (
      <ToastProvider>
        <Story />
      </ToastProvider>
    ),
  ],
};

type Story = StoryObj;

const ToastDemo: FC = () => {
  const { showToast } = useToast();

  return (
    <Box
      alignItems="center"
      display="flex"
      gap={10}
      justifyContent="flex-end"
      paddingTop={200}
      testID="toast-demo"
    >
      <Button
        onPress={() =>
          showToast({ text: "This is a default toast", variant: "success" })
        }
        testID="success-toast"
        title="Success Toast"
        variant="primary"
      />
      <Button
        onPress={() =>
          showToast({ text: "This is an error toast", variant: "error" })
        }
        testID="error-toast"
        title="Error Toast"
      />
    </Box>
  );
};

export const Default: Story = {
  render: () => <ToastDemo />,
};

export default StoryMeta;
